import React from "react";
import "./EstimatorHero.css";
import heroImg from "../../../../assets/images/estimator/estihero.jpg";

const EstimatorHero = ({ onCalculateNow }) => {
  return (
    <section className="estimator-hero">
      <div className="estimator-container">

        {/* LEFT CONTENT */}
        <div className="estimator-left">

          <span className="estimator-badge">COST ESTIMATE</span>

          <h1>
            IRQGYP Estimation <br /> Calculator
          </h1>

          <p className="estimator-desc">
            The IRQGYP Estimate Calculator helps you make fast, accurate,
            and informed project decisions before construction even begins.
          </p>

          <p className="estimator-desc">
            Developed by our technical and digital teams, this online tool
            allows architects, contractors, and project managers to calculate
            material quantities, system coverage, and cost estimates for
            gypsum-based applications, all in a few clicks.
          </p>

          <button className="estimator-btn buttongyp" type="button" onClick={onCalculateNow}>
            Calculate now
          </button>

        </div>

        {/* RIGHT IMAGE */}
        <div className="estimator-right">
          <img src={heroImg} alt="Estimator" />
        </div>

      </div>
    </section>
  );
};

export default EstimatorHero;